import request from '../shared/request';

function register(data) {
    return request({
        url: '/register',
        method: 'POST',
        data,
    });
}

function getRefreshToken(data) {
    return request({
        url: '/get-refresh-token',
        method: 'POST',
        data,
    });
}

function saveSelfie(data) {
    return request({
        url: '/selfie',
        method: 'POST',
        data,
    });
}

function processDriverLicense(data) {
    return request({
        url: '/driver-license',
        method: 'POST',
        data,
    });
}

function processPassport(data) {
    return request({
        url: '/passport',
        method: 'POST',
        data,
    });
}

function getIdentityDetails() {
    return request({
        url: '/identity-check-details',
        method: 'GET',
    });
}

function getDriversLicenseDetails() {
    return request({
        url: '/drivers-license-check-details',
        method: 'GET',
    });
}

function saveIdentityDetails(data) {
    return request({
        url: '/identity-check-details',
        method: 'POST',
        data,
    });
}

function saveDriversLicenseDetails(data) {
    return request({
        url: '/drivers-license-check-details',
        method: 'POST',
        data,
    });
}

function getPersonalDetails() {
    return request({
        url: '/personal-details',
        method: 'GET',
    });
}

function savePersonalDetails(data) {
    return request({
        url: '/personal-details',
        data,
        method: 'POST',
    });
}

function requestSms(data) {
    return request({
        url: '/validate/send-sms',
        data,
        method: 'POST',
    });
}

function validateSms(data) {
    return request({
        url: '/validate/verify-sms',
        data,
        method: 'POST',
    });
}

function requestEmail(data) {
    return request({
        url: '/validate/send-email',
        data,
        method: 'POST',
    });
}

function validateEmail(data) {
    return request({
        url: '/validate/verify-email',
        data,
        method: 'POST',
    });
}

function requestPaymentUrl(data) {
    return request({
        url: '/request-payment-url',
        method: 'POST',
    });
}

function validatePayment(data) {
    return request({
        url: '/validate-payment',
        method: 'POST',
        data,
    });
}

function processUserTerms(data) {
    return request({
        url: '/process-user-terms',
        method: 'POST',
        data,
    });
}

function getLinks() {
    return request({
        url: '/links',
        method: 'GET',
    });
}

function loadConfig(fleet, language) {
    return request({
        url: `/${fleet}/config`,
        method: 'GET',
        params: {
            ...(language && { language: language.substring(0, 2) }),
        },
    });
}

function createDocumentInstance(type) {
    return request({
        url: `/documents/${type}`,
        method: 'POST',
    });
}

function uploadDocumentImage(type, side, data) {
    return request({
        url: `/documents/${type}/${side}`,
        method: 'POST',
        data,
    });
}

function validateDocument(type) {
    return request({
        url: `/documents/${type}/validate`,
        method: 'POST',
    });
}

function getAccountStatus() {
    return request({
        url: `/account-status`,
        method: 'GET',
    });
}

function submitPromocode(promocode) {
    return request({
        url: `/promocode/${promocode}`,
        method: 'POST',
    });
}

function getFormVersion(version) {
    return request({
        url: `/version`,
        method: 'GET',
    });
}

function getServices() {
    return request({
        url: `/services`,
        method: 'GET',
    });
}

function saveServices(data) {
    return request({
        url: `/services`,
        method: 'POST',
        data: {
            services: data,
        },
    });
}

function processApplication() {
    return request({
        url: `/process-application`,
        method: 'POST',
    });
}

function tokenSigning(token) {
    return request({
        url: `/token-signin`,
        method: 'GET',
        params: {
            token,
        },
    });
}

function selfIdentityCheck(data) {
    return request({
        url: `/self-identity-check`,
        method: 'POST',
        data,
    });
}

function selfDriversLicenseCheck(data) {
    return request({
        url: `/self-drivers-license-check`,
        method: 'POST',
        data,
    });
}

function getSubscriptions() {
    return request({
        url: `/subscriptions`,
        method: 'GET',
    });
}

function createSubscription(planId) {
    return request({
        url: `/subscriptions/${planId}`,
        method: 'POST',
    });
}

function getBankIdWidgetUrl() {
    return request({
        url: `/bankid/oauth`,
        method: 'GET',
    });
}
function getCountries() {
    return [
        { value: '', label: '' },
        { value: 'AFG', label: 'Afghanistan' },
        { value: 'ALB', label: 'Albania' },
        { value: 'DZA', label: 'Algeria' },
        { value: 'ASM', label: 'American Samoa' },
        { value: 'AND', label: 'Andorra' },
        { value: 'AGO', label: 'Angola' },
        { value: 'AIA', label: 'Anguilla' },
        { value: 'ATG', label: 'Antigua and Barbuda' },
        { value: 'ARG', label: 'Argentina' },
        { value: 'ARM', label: 'Armenia' },
        { value: 'ABW', label: 'Aruba' },
        { value: 'AUS', label: 'Australia' },
        { value: 'AUT', label: 'Austria' },
        { value: 'AZE', label: 'Azerbaijan' },
        { value: 'BHR', label: 'Bahrain' },
        { value: 'BGD', label: 'Bangladesh' },
        { value: 'BRB', label: 'Barbados' },
        { value: 'BLR', label: 'Belarus' },
        { value: 'BEL', label: 'Belgium' },
        { value: 'BLZ', label: 'Belize' },
        { value: 'BEN', label: 'Benin' },
        { value: 'BMU', label: 'Bermuda' },
        { value: 'BTN', label: 'Bhutan' },
        { value: 'BOL', label: 'Bolivia' },
        { value: 'BES', label: 'Bonaire, Sint Eustatius and Saba' },
        { value: 'BIH', label: 'Bosnia and Herzegovina' },
        { value: 'BWA', label: 'Botswana' },
        { value: 'BRA', label: 'Brazil' },
        { value: 'IOT', label: 'British Indian Ocean Territory' },
        { value: 'VGB', label: 'British Virgin Islands' },
        { value: 'BRN', label: 'Brunei Darussalam' },
        { value: 'BGR', label: 'Bulgaria' },
        { value: 'BFA', label: 'Burkina Faso' },
        { value: 'MMR', label: 'Myanmar' },
        { value: 'BDI', label: 'Burundi' },
        { value: 'KHM', label: 'Cambodia' },
        { value: 'CMR', label: 'Cameroon' },
        { value: 'CAN', label: 'Canada' },
        { value: 'CPV', label: 'Cabo Verde' },
        { value: 'CYM', label: 'Cayman Islands' },
        { value: 'CAF', label: 'Central African Republic' },
        { value: 'TCD', label: 'Chad' },
        { value: 'CHL', label: 'Chile' },
        { value: 'CHN', label: 'China' },
        { value: 'COL', label: 'Colombia' },
        { value: 'COM', label: 'Comoros' },
        { value: 'COK', label: 'Cook Islands' },
        { value: 'CRI', label: 'Costa Rica' },
        { value: 'CIV', label: 'Côte dIvoire' },
        { value: 'HRV', label: 'Croatia' },
        { value: 'CUB', label: 'Cuba' },
        { value: 'CUW', label: 'Curaçao' },
        { value: 'CYP', label: 'Cyprus' },
        { value: 'CZE', label: 'Czechia' },
        { value: 'DNK', label: 'Denmark' },
        { value: 'DJI', label: 'Djibouti' },
        { value: 'DMA', label: 'Dominica' },
        { value: 'DOM', label: 'Dominican Republic' },
        { value: 'ECU', label: 'Ecuador' },
        { value: 'EGY', label: 'Egypt' },
        { value: 'SLV', label: 'El Salvador' },
        { value: 'GNQ', label: 'Equatorial Guinea' },
        { value: 'ERI', label: 'Eritrea' },
        { value: 'EST', label: 'Estonia' },
        { value: 'ETH', label: 'Ethiopia' },
        { value: 'FLK', label: 'Falkland Islands' },
        { value: 'FRO', label: 'Faroe Islands' },
        { value: 'FSM', label: 'Federated States of Micronesia' },
        { value: 'FJI', label: 'Fiji' },
        { value: 'FIN', label: 'Finland' },
        { value: 'FRA', label: 'France' },
        { value: 'GUF', label: 'French Guiana' },
        { value: 'PYF', label: 'French Polynesia' },
        { value: 'GAB', label: 'Gabon' },
        { value: 'GEO', label: 'Georgia' },
        { value: 'DEU', label: 'Germany' },
        { value: 'GHA', label: 'Ghana' },
        { value: 'GIB', label: 'Gibraltar' },
        { value: 'GRC', label: 'Greece' },
        { value: 'GRL', label: 'Greenland' },
        { value: 'GRD', label: 'Grenada' },
        { value: 'GLP', label: 'Guadeloupe' },
        { value: 'GUM', label: 'Guam' },
        { value: 'GTM', label: 'Guatemala' },
        { value: 'GGY', label: 'Guernsey' },
        { value: 'GIN', label: 'Guinea' },
        { value: 'GNB', label: 'Guinea-Bissau' },
        { value: 'GUY', label: 'Guyana' },
        { value: 'HTI', label: 'Haiti' },
        { value: 'HND', label: 'Honduras' },
        { value: 'HKG', label: 'Hong Kong' },
        { value: 'HUN', label: 'Hungary' },
        { value: 'ISL', label: 'Iceland' },
        { value: 'IND', label: 'India' },
        { value: 'IDN', label: 'Indonesia' },
        { value: 'IRN', label: 'Iran' },
        { value: 'IRQ', label: 'Iraq' },
        { value: 'IRL', label: 'Ireland' },
        { value: 'ISR', label: 'Israel' },
        { value: 'ITA', label: 'Italy' },
        { value: 'JAM', label: 'Jamaica' },
        { value: 'JPN', label: 'Japan' },
        { value: 'JEY', label: 'Jersey' },
        { value: 'JOR', label: 'Jordan' },
        { value: 'KAZ', label: 'Kazakhstan' },
        { value: 'KEN', label: 'Kenya' },
        { value: 'KIR', label: 'Kiribati' },
        { value: 'KWT', label: 'Kuwait' },
        { value: 'KGZ', label: 'Kyrgyzstan' },
        { value: 'LAO', label: 'Laos' },
        { value: 'LVA', label: 'Latvia' },
        { value: 'LBN', label: 'Lebanon' },
        { value: 'LSO', label: 'Lesotho' },
        { value: 'LBR', label: 'Liberia' },
        { value: 'LBY', label: 'Libya' },
        { value: 'LIE', label: 'Liechtenstein' },
        { value: 'LTU', label: 'Lithuania' },
        { value: 'LUX', label: 'Luxembourg' },
        { value: 'MAC', label: 'Macao' },
        { value: 'MKD', label: 'Macedonia' },
        { value: 'MDG', label: 'Madagascar' },
        { value: 'MWI', label: 'Malawi' },
        { value: 'MYS', label: 'Malaysia' },
        { value: 'MDV', label: 'Maldives' },
        { value: 'MLI', label: 'Mali' },
        { value: 'MLT', label: 'Malta' },
        { value: 'MHL', label: 'Marshall Islands' },
        { value: 'MTQ', label: 'Martinique' },
        { value: 'MRT', label: 'Mauritania' },
        { value: 'MUS', label: 'Mauritius' },
        { value: 'MYT', label: 'Mayotte' },
        { value: 'MEX', label: 'Mexico' },
        { value: 'MDA', label: 'Moldova' },
        { value: 'MCO', label: 'Monaco' },
        { value: 'MNG', label: 'Mongolia' },
        { value: 'MNE', label: 'Montenegro' },
        { value: 'MSR', label: 'Montserrat' },
        { value: 'MAR', label: 'Morocco' },
        { value: 'MOZ', label: 'Mozambique' },
        { value: 'NAM', label: 'Namibia' },
        { value: 'NRU', label: 'Nauru' },
        { value: 'NPL', label: 'Nepal' },
        { value: 'NLD', label: 'Netherlands' },
        { value: 'ANT', label: 'Netherlands Antilles' },
        { value: 'NCL', label: 'New Caledonia' },
        { value: 'NZL', label: 'New Zealand' },
        { value: 'NIC', label: 'Nicaragua' },
        { value: 'NER', label: 'Niger' },
        { value: 'NGA', label: 'Nigeria' },
        { value: 'NIU', label: 'Niue' },
        { value: 'NFK', label: 'Norfolk Island' },
        { value: 'PRK', label: 'North Korea' },
        { value: 'MNP', label: 'Northern Mariana Islands' },
        { value: 'NOR', label: 'Norway' },
        { value: 'OMN', label: 'Oman' },
        { value: 'PAK', label: 'Pakistan' },
        { value: 'PLW', label: 'Palau' },
        { value: 'PSE', label: 'Palestine' },
        { value: 'PAN', label: 'Panama' },
        { value: 'PNG', label: 'Papua New Guinea' },
        { value: 'PRY', label: 'Paraguay' },
        { value: 'PER', label: 'Peru' },
        { value: 'PHL', label: 'Philippines' },
        { value: 'POL', label: 'Poland' },
        { value: 'PRT', label: 'Portugal' },
        { value: 'PRI', label: 'Puerto Rico' },
        { value: 'QAT', label: 'Qatar' },
        { value: 'COG', label: 'Congo' },
        { value: 'REU', label: 'Réunion' },
        { value: 'ROU', label: 'Romania' },
        { value: 'RUS', label: 'Russia' },
        { value: 'RWA', label: 'Rwanda' },
        { value: 'BLM', label: 'Saint Barthélemy' },
        { value: 'SHN', label: 'Saint Helena' },
        { value: 'KNA', label: 'Saint Kitts and Nevis' },
        { value: 'MAF', label: 'Saint Martin' },
        { value: 'SPM', label: 'Saint Pierre and Miquelon' },
        { value: 'VCT', label: 'Saint Vincent and the Grenadines' },
        { value: 'WSM', label: 'Samoa' },
        { value: 'SMR', label: 'San Marino' },
        { value: 'STP', label: 'São Tomé and Príncipe' },
        { value: 'SAU', label: 'Saudi Arabia' },
        { value: 'SEN', label: 'Senegal' },
        { value: 'SRB', label: 'Serbia' },
        { value: 'SYC', label: 'Seychelles' },
        { value: 'SLE', label: 'Sierra Leone' },
        { value: 'SGP', label: 'Singapore' },
        { value: 'SXM', label: 'Sint Maarten (Dutch part)' },
        { value: 'SVK', label: 'Slovakia' },
        { value: 'SVN', label: 'Slovenia' },
        { value: 'SLB', label: 'Solomon Islands' },
        { value: 'SOM', label: 'Somalia' },
        { value: 'ZAF', label: 'South Africa' },
        { value: 'KOR', label: 'South Korea' },
        { value: 'SSD', label: 'South Sudan' },
        { value: 'ESP', label: 'Spain' },
        { value: 'LKA', label: 'Sri Lanka' },
        { value: 'LCA', label: 'Saint Lucia' },
        { value: 'SDN', label: 'Sudan' },
        { value: 'SUR', label: 'Suriname' },
        { value: 'SWZ', label: 'Swaziland' },
        { value: 'SWE', label: 'Sweden' },
        { value: 'CHE', label: 'Switzerland' },
        { value: 'SYR', label: 'Syrian Arab Republic' },
        { value: 'TWN', label: 'Taiwan' },
        { value: 'TJK', label: 'Tajikistan' },
        { value: 'TZA', label: 'Tanzania' },
        { value: 'THA', label: 'Thailand' },
        { value: 'BHS', label: 'Bahamas' },
        { value: 'GMB', label: 'Gambia' },
        { value: 'TLS', label: 'Timor-Leste' },
        { value: 'TGO', label: 'Togo' },
        { value: 'TKL', label: 'Tokelau' },
        { value: 'TON', label: 'Tonga' },
        { value: 'TTO', label: 'Trinidad and Tobago' },
        { value: 'TUN', label: 'Tunisia' },
        { value: 'TUR', label: 'Turkey' },
        { value: 'TKM', label: 'Turkmenistan' },
        { value: 'TCA', label: 'Turks and Caicos Islands' },
        { value: 'TUV', label: 'Tuvalu' },
        { value: 'UGA', label: 'Uganda' },
        { value: 'UKR', label: 'Ukraine' },
        { value: 'ARE', label: 'United Arab Emirates' },
        { value: 'GBR', label: 'United Kingdom' },
        { value: 'USA', label: 'United States' },
        { value: 'URY', label: 'Uruguay' },
        { value: 'VIR', label: 'U.S. Virgin Islands' },
        { value: 'UZB', label: 'Uzbekistan' },
        { value: 'VUT', label: 'Vanuatu' },
        { value: 'VAT', label: 'Vatican City' },
        { value: 'VEN', label: 'Venezuela' },
        { value: 'VNM', label: 'Vietnam' },
        { value: 'WLF', label: 'Wallis and Futuna' },
        { value: 'YEM', label: 'Yemen' },
        { value: 'ZMB', label: 'Zambia' },
        { value: 'ZWE', label: 'Zimbabwe' },
    ];
}

function getStates(country) {
    const caStates = {
        AB: 'Alberta',
        BC: 'British Columbia',
        MB: 'Manitoba',
        NB: 'New Brunswick',
        NL: 'Newfoundland and Labrador',
        NS: 'Nova Scotia',
        NT: 'Northwest Territories',
        NU: 'Nunavut',
        ON: 'Ontario',
        PE: 'Prince Edward Island',
        QC: 'Québec',
        SK: 'Saskatchewan',
        YT: 'Yukon',
    };

    const usStates = {
        AL: 'Alabama',
        AK: 'Alaska',
        AS: 'American Samoa',
        AZ: 'Arizona',
        AR: 'Arkansas',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DE: 'Delaware',
        DC: 'District Of Columbia',
        FL: 'Florida',
        GA: 'Georgia',
        GU: 'Guam',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        MP: 'Northern Mariana Islands',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PA: 'Pennsylvania',
        PR: 'Puerto Rico',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VI: 'Virgin Islands',
        VA: 'Virginia',
        WA: 'Washington',
        WV: 'West Virginia',
        WI: 'Wisconsin',
        WY: 'Wyoming',
    };
    let states = usStates;
    if (country === 'CAN') {
        states = caStates;
    }
    return [
        { value: '', label: '' },
        ...Object.keys(states).map(code => {
            return {
                value: code,
                label: states[code],
            };
        }),
    ];
}

function documentClassification(type) {
    return request({
        url: `/documents/${type}/classification`,
    });
}

function documentImageQuality(type) {
    return request({
        url: `/documents/${type}/metrics`,
    });
}

function getCurrency() {
    return request({
        url: `/conf`,
        method: 'GET',
    });
}

function processBCAAMembership(data) {
    return request({
        url: `/bcaa/membership`,
        method: 'POST',
        data,
    });
}

function getPubKey() {
    return request({
        url: `/stripe-get-pub-key`,
        method: 'GET',
    });
}

function postSetupIntent(data) {
    return request({
        url: `/stripe-get-setup-intent`,
        method: 'POST',
        data,
    });
}

function stripeValidatePayment() {
    return request({
        url: `/stripe-validate-payment`,
        method: 'POST',
    });
}

function processBankidAuth(data) {
    return request({
        url: `/bankid/process`,
        method: 'POST',
        data,
    });
}

function getUserProperties() {
    return request({
        url: `/user-properties`,
        method: 'GET',
    });
}

function getCities(fleetId) {
    return request({
        url: `/${fleetId}/cities`,
        method: 'GET',
    });
}

function getPaymentMethod() {
    return request({
        url: '/get-payment-method',
        method: 'GET',
    });
}

function makeAPayment(data) {
    return request({
        url: '/make-a-payment',
        method: 'POST',
        data,
    });
}

function getPaymentResultDetails(data) {
    return request({
        url: '/get-result-details',
        method: 'POST',
        data,
    });
}

function getFiscalCodeCities(data) {
    return request({
        url: `/fiscal-code-cities/${data}`,
        method: 'GET',
    });
}

function setFiscalCode(data) {
    return request({
        url: `/set-fiscal-code/${data}`,
        method: 'POST',
    });
}

function savePersonalBirthplaces(data) {
    return request({
        url: `/save-personal-birthplaces`,
        method: 'POST',
        data,
    });
}

const AuthService = {
    register,
    saveSelfie,
    processPassport,
    processDriverLicense,
    getIdentityDetails,
    saveIdentityDetails,
    getDriversLicenseDetails,
    saveDriversLicenseDetails,
    getPersonalDetails,
    savePersonalDetails,
    requestSms,
    validateSms,
    requestPaymentUrl,
    validatePayment,
    processUserTerms,
    getLinks,
    loadConfig,
    createDocumentInstance,
    uploadDocumentImage,
    validateDocument,
    getAccountStatus,
    submitPromocode,
    getFormVersion,
    getServices,
    saveServices,
    processApplication,
    tokenSigning,
    selfIdentityCheck,
    selfDriversLicenseCheck,
    getCountries,
    documentClassification,
    documentImageQuality,
    getStates,
    getSubscriptions,
    createSubscription,
    getCurrency,
    processBCAAMembership,
    getPubKey,
    postSetupIntent,
    stripeValidatePayment,
    getBankIdWidgetUrl,
    processBankidAuth,
    getUserProperties,
    getRefreshToken,
    getCities,
    getPaymentMethod,
    makeAPayment,
    getPaymentResultDetails,
    validateEmail,
    requestEmail,
    getFiscalCodeCities,
    setFiscalCode,
    savePersonalBirthplaces,
};

export default AuthService;
